import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { MplusPopup } from '../mplus-popup'

import s from './styles.module.scss'

interface Props {
  totalInfo?: string
  monthPayInfo?: string
}

export const TotalPrice: FC<Props> = ({ totalInfo, monthPayInfo }) => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const onOpenDialog = () => {
    openDialog({
      child: (
        <MplusPopup
          title={t('mplus.monthly_payment')}
          description={t('mplus.mplus_each_month_pay_info_desc', {
            price: priceShow(monthPayInfo),
          })}
        />
      ),
      isDialog: false,
    })
  }
  return (
    <div className={s.totalPrice}>
      <p className={clsx(s.nowToPay, 'bold-16')}>
        {t('mplus.to_pay_current')}
        <span>0 &#8384;</span>
      </p>

      <p
        className={clsx(s.nowToPay, 'medium-14')}
        onClick={onOpenDialog}
      >
        <span className={s.totalInfo}>
          {t('mplus.from_next_month')}

          <AppIcon
            width={16}
            height={16}
            id={AllIcons.INFO}
            className={s.icon}
          />
        </span>

        <span>{priceShow(monthPayInfo)} &#8384;</span>
      </p>
      <p className={clsx(s.nowToPay, 'medium-14')}>
        {t('mplus.total_sum')}

        <span>{priceShow(totalInfo)} &#8384;</span>
      </p>
    </div>
  )
}
